export const COLORS = {
  light: "255, 255, 255",
  lightText: "255, 255, 255",
  primary: "0, 0, 0",
  secondary: "147, 186, 163",

  nav: "rgb(0, 0, 0)",
  shadow: "58, 32, 10",
  shadow_dark_RGBA: "rgba(0, 0, 0, 0.3)",
  shadow_RGBA: "rgba(58, 32, 10, 0.9)",
  violet: "27, 24, 87",
  violet_RGB: "rgb(27, 24, 87)",
  //background: "rgb(70,81,91)", //blau grau
  background: "rgb(35, 45, 54)", //dunkel blau grau
  header: "rgb(255, 165, 0)", // gelb
  header_NUM: "255, 206, 115", // hellgelb
  headline: "#17bf98", // helltürkis 06012022

  footer: "#09ac86", // 06012022
  footer_alt: "rgb(51, 112, 101)", // türkis
  background1_NUM: "147, 186, 163",
  background2_NUM: "205, 151, 151" /* rosa*/,
};

export const VIEWPORT = {
  smMin: "270px", // Small devices (landscape phones, 270px upto 768px  )
  smMax: "767px",
  mMin: "768px", // Medium devices (tablets, 768px upto 992px )
  mMax: "992px",
  lMin: "993px", // Large devices (desktops, 992px and up)

  small: "@media (min-width: 270px) and (max-width: 767px)",
  medium: "@media (min-width: 768px) and (max-width: 992px)",
  large: "@media (min-width: 992px)",
};
